import React from 'react';
const Wrapper = ({ title, children }) => (
    <>
        {children}
    </>
);
export default Wrapper;                    